import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Modal } from '../elements-modal/modal';
import { FormBuilder } from 'shared-components/forms/form';
import { RadioGroup } from '../elements-inputs/radio-group';
import Bookings from '../../../api/api-bookings';
import Contracts from '../../../api/api-contracts';
import { FormattedMessage } from 'react-intl';

export class WithdrawUpdateModal extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      errorText: ''
    };

    this.withdrawAction = this.withdrawAction.bind(this);
    this.withdrawActionCb = this.withdrawActionCb.bind(this);
  }

  closeBehavior () {
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
    $('#modal-container').modal('hide');
  }

  withdrawAction (form, cb, refs) {
    const { bookingID, hasNoContracts, bookingData, user } = this.props;
    const viewAs = this.props.viewAs.toLowerCase();
    const hostWithContracts = 'host' === viewAs && !hasNoContracts;

    const path = 'guest' === viewAs ?
      `${bookingID}/guest/update/withdraw`
      :
      `${bookingID}/host/host_update/withdraw`;

    const value = refs.radio.returnRadioGroupValue();
    const payload = !hasNoContracts ?
      { reason: value }
      :
      { withdraw_reason: value };

    if (hostWithContracts) {
      return Contracts.withdrawHostUpdate(payload, bookingID, PSSessions.Cookies('PSAccess'), cb);
    }

    if (hasNoContracts) {
      return Bookings.updateAction(payload, PSSessions.Cookies('PSAccess'), path, cb);
    }

    // only fire event if guest update withdraw with contracts
    const analyticsProperties = {
      booking_id: bookingID,
      guest_id: get(user, 'SSOid', ''),
      host_id: get(bookingData, 'host.sso_id', ''),
      withdraw_reason: value
    };
    analyticsIntegrations.guestUpdateWithdraw(analyticsProperties);

    return Contracts.updateGuestUpdate(payload, bookingID, PSSessions.Cookies('PSAccess'), 'withdraw', cb);
  }

  withdrawActionCb (response) {
    if (200 === response.statusCode) {
      this.closeBehavior();
      this.props.callback();
    } else {
      this.setState({
        errorText: 'An error occurred. Please refresh the page and try again.'
      });
    }
  }

  modalBody () {
    const viewAs = this.props.viewAs.toLowerCase();
    const other = 'host' === viewAs ? 'guest' : 'host';
    const guestInputData = [
      {
        ID: 'dates-changing',
        value: 'My dates are changing',
        displayText: <FormattedMessage id='inbox.withdraw_update_modal.dates_changing' defaultMessage='My dates are changing.' />
      },
      {
        ID: 'event-cancelled',
        value: 'My event was cancelled',
        displayText: <FormattedMessage id='inbox.withdraw_update_modal.event_cancelled' defaultMessage='My event was cancelled.' />
      },
      {
        ID: 'another-space',
        value: 'I found another space',
        displayText: <FormattedMessage id='inbox.withdraw_update_modal.another_space' defaultMessage='I found another space.' />
      },
      {
        ID: 'new-update',
        value: 'I need to make another update',
        displayText: <FormattedMessage id='inbox.withdraw_update_modal.another_update' defaultMessage='I need to make another update.' />
      },
      {
        ID: 'other',
        value: '',
        displayText: <FormattedMessage id='inbox.withdraw_update_modal.guest_other' defaultMessage='Other' />,
        collectUserInput: true
      }
    ];
    const hostInputData = [
      {
        ID: 'new-update',
        value: 'I need to revise this update',
        displayText: <FormattedMessage id='inbox.withdraw_update_modal.revise_update' defaultMessage='I need to revise this update' />
      },
      {
        ID: 'space-fit',
        value: 'My space is no longer a fit for this activity',
        displayText: <FormattedMessage id='inbox.withdraw_update_modal.space_activity' defaultMessage='My space is no longer a fit for this activity' />
      },
      {
        ID: 'other',
        value: '',
        displayText: <FormattedMessage id='inbox.withdraw_update_modal.host_other' defaultMessage='Other' />,
        collectUserInput: true
      }
    ];

    return (
      <div className="withdraw-update-modal col-xs-12" style={{ paddingBottom: 40 }}>
        <p className="gutter">
          <FormattedMessage
            id='inbox.withdraw_update_modal.why_withdrawing'
            defaultMessage={ 'Tell the {other} why you\'re withdrawing your update request.' }
            values={{
              other: other
            }}
          />
        </p>
        <FormBuilder
          formname="decline-update-form"
          formStyle="modal-plus"
          formInputs={ [{ custom: () => {
            return (
              <RadioGroup
                isRequired
                ref="radio"
                inputData={ 'host' === viewAs ? hostInputData : guestInputData }
                groupName="withdraw-reason"
              />);
          } }] }
          submitAction={ this.withdrawAction }
          submitCallback={ this.withdrawActionCb }
          isButtonDisabled={ false }
          buttonText={ <FormattedMessage id="inbox.withdraw_update_modal.withdraw" defaultMessage="Withdraw"/> }
          errorText={ this.state.errorText }
          beforeCTA={
            <div className="col-xs-12">
              <hr style={{ marginTop: 0 }} />
              <p><FormattedMessage id='inbox.withdraw_update_modal.after_withdraw' defaultMessage='After you withdraw, your original booking will still be confirmed.' /></p>
            </div>
          }
        />
      </div>
    );
  }

  render () {
    return (
      <Modal
        addCloseIcon
        show
        modalID="withdraw-update-modal"
        modalSize="sm-size"
        modalType="standard"
        header={ <FormattedMessage id="inbox.withdraw_update_modal.withdraw_update" defaultMessage="Withdraw update request"/> }
        body={ this.modalBody() }
      />
    );
  }
}


WithdrawUpdateModal.propTypes = {
  bookingID: PropTypes.string,
  callback: PropTypes.func,
  viewAs: PropTypes.string
};
